const storage = {
  local: window.localStorage,
  session: window.sessionStorage,
};

export const StorageType = {
  Local: 'local',
  Session: 'session',
};

export function createStorage(key, fallback, config) {
  let cache = null;
  let listeners = [];

  const _getDataFromStorage = async () => {
    // const value = storage[storageType].getItem(key);
    // return deserialize(value) ?? fallback;
    const data = await window.localforage.getItem(key);
    return data ?? fallback;
  };

  const _emitChange = () => {
    listeners.forEach(listener => listener());
  };

  const set = async value => {
    // 可以存 Object，但有 proxy 时会报错
    value = JSON.parse(JSON.stringify(value));

    cache = value;
    try{
      // storage[storageType].setItem(key, serialize(value));
      await window.localforage.setItem(key, value);
    } catch(e){}
  };

  const subscribe = listener => {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  };

  const getSnapshot = () => {
    return cache;
  };

  cache = _getDataFromStorage();

  return {
    get: _getDataFromStorage,
    set,
    getSnapshot,
    subscribe,
  };
}
